import { Outlet, Navigate } from 'react-router-dom';
import SessionService from '../../services/session';

export default function AuthLayout() {
  const isAuthenticated = SessionService.isAuthenticated();

  return isAuthenticated ? <Navigate to="/management" /> : <Outlet />;
}
